import moment from 'moment-timezone'

import StyledPaper from '/components/paper'
import { Typography } from '@mui/material'

const SupportThreadMessages = ({messages}) => {

  return (
    <div className='flex flex-col gap-0 w-full'>
      {messages.map((item,i) => <MessageItem key={i} item={item}/>)}
    </div>
  )
}

export default SupportThreadMessages

const MessageItem = ({item}) => {

  const classes = "w-3/4 " + (item.isSmartixStaff ? "self-end text-blue-200" : "self-start text-green-200")

  return (
    <StyledPaper classes={classes}>
      <div className='flex flex-row justify-between w-full mb-3'>
        <Typography variant="h5" color="textSecondary">{item.username}</Typography>
        <Typography variant="caption" color="textSecondary">{item ? moment(item.created,"YYYYMMDDHHmmSS").format("DD/MM/YYYY HH:mm") : ""}</Typography>
      </div>
      
      {item.message}

    </StyledPaper>
  )
}